import React, { useEffect } from 'react';
import Modal from './Modal';
import AOS from 'aos';
import 'aos/dist/aos.css'; 

const Sucursales = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
  <div className="section-contacto">
    <div className="container mt-5">
      <h2 className="text-center font-weight-bold" data-aos="fade-up">Ubicación</h2>
      
      <div className="mt-4" data-aos="fade-up">
        <p className="text-muted">
        Estamos ubicados en los cantones de Cayambe y Pedro Moncayo, donde ofrecemos una amplia variedad de productos, herramientas y materiales de construcción, también brindamos asesoría experta para ayudar a nuestros clientes a elegir los materiales más adecuados para sus proyectos.
        </p>
      </div>
      <div className="banner">
        <h3 className="text-center mt-5 font-weight-bold">Cayambe local Matriz</h3>
      </div>
      <div className="row mt-4">
        <div className="col-md-6 text-center" data-aos="fade-right">
          <img src="./images/local-matriz.png" alt="local matriz" className="img-fluid img-sede" data-toggle="modal" data-target="#modalMatriz"/>
        </div>
        
        <div className="col-md-6" data-aos="fade-left">
          <h4 className="font-weight-bold ml-2">Dirección</h4>
          <p className="text-muted">Av. Natalia Jarrín s6-32 y Venezuela. <strong>Referencia:</strong>(Frente a la estación de servicios Primax)</p>
          
          <h4 className="font-weight-bold ml-2">Horario de Atención</h4>
          <p className="text-muted mt-1">
            <strong>Lunes a Viernes:</strong> 6:00 AM - 18:30 PM<br />
            <strong>Sábado:</strong> 07:00 AM - 18:00 PM<br />
            <strong>Domingo:</strong> 07:00 AM - 13:00 PM
          </p>
          
          <h4 className="font-weight-bold ml-2">Contactos</h4>
          <p className="text-muted">
            <a href="tel:+593994888600" target="_blank" className="d-flex align-items-center contact-link">
              <img width="25" height="20" src="https://img.icons8.com/ios-filled/50/phone.png" alt="phone" />
              0994888600
            </a>
          </p>
        </div>
      </div>

      <div className="banner">
        <h3 className="text-center mt-5 font-weight-bold">Cayambe local Sigsal</h3>
      </div>
      <div className="row mt-4">
        <div className="col-md-6 text-center" data-aos="fade-right">
          <img src="./images/local-sigsal.jpg" alt="local matriz" className="img-fluid img-sede" data-toggle="modal" data-target="#modalSigsal"/>
        </div>
        
        <div className="col-md-6" data-aos="fade-left">
          <h4 className="font-weight-bold ml-2">Dirección</h4>
          <p className="text-muted">Av. Eloy alfaro y Primavera esquina. <strong>Referencia:</strong> (Entrada al barrio Sigsal, junto a las bodegas de Nestlé)</p>
          
          <h4 className="font-weight-bold ml-2">Horario de Atención</h4>
          <p className="text-muted mt-1">
            <strong>Lunes a Viernes:</strong> 7:00 AM - 18:00 PM<br />
            <strong>Sábado:</strong> 07:00 AM - 14:00 PM<br />
          </p>
          
          <h4 className="font-weight-bold ml-2">Contactos</h4>
          <p className="text-muted">
            <a href="tel:+593986174969" target="_blank" className="d-flex align-items-center contact-link">
              <img width="25" height="20" src="https://img.icons8.com/ios-filled/50/phone.png" alt="phone" />
              0986174969
            </a>
          </p>
        </div>
      </div>

      <div className="banner">
        <h3 className="text-center mt-5 font-weight-bold">Local Tabacundo</h3>
      </div>
      <div className="row mt-4">
        <div className="col-md-6 text-center" data-aos="fade-right">
          <img src="./images/local-tabacundo.png" alt="local matriz" className="img-fluid img-sede" data-toggle="modal" data-target="#modalTabacundo"
          />
        </div>
        
        <div className="col-md-6" data-aos="fade-left">
          <h4 className="font-weight-bold ml-2">Dirección</h4>
          <p className="text-muted">Panamericana Norte S/N vía Quito <strong>Referencia: </strong>(Frente a la estación de servicios Petroworld)</p>
          
          <h4 className="font-weight-bold ml-2">Horario de Atención</h4>
          <p className="text-muted mt-1">
            <strong>Lunes a Viernes:</strong> 07:00 AM - 18:00 PM <br />
            <strong>Sábado:</strong>07:00 AM - 18:00 PM <br />
            <strong>Domingo:</strong>07:00 AM - 13:00 PM 
          </p>
          
          <h4 className="font-weight-bold ml-2">Contactos</h4>
          <p className="text-muted">
            <a href="tel:+593982327719" target="_blank" className="d-flex align-items-center contact-link">
              <img width="25" height="20" src="https://img.icons8.com/ios-filled/50/phone.png" alt="phone" />
              0982327719
            </a>
          </p>
        </div>
      </div>

      <div className="banner-maps">
        <div className="mt-4 text-center" data-aos="fade-up-right">
            <h4 className="font-weight-bold" data-aos="fade-up-right" >Encuentrenos por Google Maps en nuestro local matriz Cayambe </h4>
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d625.3571352397769!2d-78.1477541536801!3d0.03705627447293577!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e2a08f8f511a6bf%3A0x8e518252cf41d633!2sFerreter%C3%ADa%20El%20Constructor%20Cayambe!5e1!3m2!1ses!2sec!4v1743705673391!5m2!1ses!2sec" 
              width="100%" 
              height="450" 
              style={{ border: 0 }} 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
      </div>
      <div className="frase mt-4" >
        ¡La rapidez nuestro compromiso, la variedad nuestra ventaja y la calidad nuestro respaldo! 
      </div>
    </div>
  </div>
  );
};

export default Sucursales;